module.exports = __webpack_public_path__ + "img/Buildself.5ae39533.png";